import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'
import { Row, Col, Card } from 'antd'

import LinearChartLive from '../../charts/LinearChartLive'
import Indicator from '../../charts/Indicator'
import FlowTable from '../../charts/FlowTable'
import { LoadingChart } from '../../utils/Utils'

class Flow extends Component {
  render () {
    let { lastUpdate, lastValue, data, populated, title, dataVolumen, volumenToday } = this.props
    return (
      <Row type='flex' justify='center' gutter={8} style={{padding: '10px'}}>
        <Col span={24} align='center' >
          <Card bodyStyle={{padding: '0'}} style={{marginBottom: '10px'}}>
            {populated
              ? <LinearChartLive
                unit='MCP/H'
                title={title}
                data={data}
                lastValue={[lastUpdate, lastValue]}
                color='#faad14'
                ylabel='Thousand Cubic Feet per Hour'
                type='spline' />
              : <LoadingChart />
            }
          </Card>
        </Col>
        <Col md={19} xs={24}>
          <Card bodyStyle={{padding: '5px'}} style={{marginBottom: '10px'}}>
            <FlowTable
              delta={-60 * 60 * 5}
              unit='MFC'
              title='VOLUMEN MOCHILEROS'
              pageSize={7}
              data={dataVolumen}
              current={volumenToday}
            />
          </Card>
        </Col>
        <Col md={5} xs={24}>
          <Card bodyStyle={{ padding: '10px' }} style={{ marginBottom: '10px' }}>
            <Indicator
              value={lastValue}
              type='icon-graphic_eq'
              title='cf_flow'
              colors={['#a0d911', '#a0d911', '#f5222d']}
              threshold={[0, 100]}
              unit='MCF/H'
            />
          </Card>
        </Col>
      </Row>
    )
  }
}

Flow.propTypes = {
  title: PropTypes.string,
  lastValue: PropTypes.number,
  lastUpdate: PropTypes.number,
  data: PropTypes.array,
  populated: PropTypes.bool
}

function mapStateToProps (state) {
  let { mochileros } = state.locations
  return {
    dataVolumen: mochileros.indicators.cfvolumen_total_day.data,
    volumenToday: mochileros.indicators.cfvolumen_current_day.lastValue,
    lastValue: mochileros.indicators.cfflow.lastValue,
    lastUpdate: mochileros.indicators.cfflow.lastUpdate,
    populated: mochileros.indicators.cfflow.populated,
    data: mochileros.indicators.cfflow.data,
    title: `CF FLOW MOCHILEROS`
  }
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Flow)



// WEBPACK FOOTER //
// ./src/boards/mochileros/Flow.js